import { MainLayoutComponent } from '@components/main-layout/main-layout.component';
import { Routes } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { I18nComponent } from './i18n/i18n.component';
import { TranslationsListComponent } from './i18n/translations-list/translations-list.component';
import { TranslationCrudComponent } from './i18n/translation-crud/translation-crud.component';

export const i18nRoutes: Routes = [
    {
        path: 'admin/i18n',
        component: MainLayoutComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'USER_MANAGEMENT',
                redirectTo: '/'
            }
        },
        children: [
            {
                path: '',
                component: I18nComponent,
                children: [
                    {
                        path: ':iso2code/list',
                        component: TranslationsListComponent
                    },
                    {
                        path: ':iso2code/crud/:key',
                        component: TranslationCrudComponent
                    },
                    {
                        path: ':iso2code/crud',
                        component: TranslationCrudComponent
                    }                  
                ]
            },

        ]
    }
];
